import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';

import { parseInline, Segment } from '../utils/release-note-markdown.util';

/**
 * Renders authored release-note text — heading, benefit, every bullet, on every surface — from
 * {@link parseInline} segments: `<b>`, `<a target="_blank" rel="noopener">`, and interpolated text.
 * 🔴 No `[innerHTML]`, no `bypassSecurityTrustHtml`: authored text is data, never markup.
 */
@Component({
  selector: 'rms-release-note-rich-text',
  templateUrl: './release-note-rich-text.component.html',
  styleUrls: ['./release-note-rich-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ReleaseNoteRichTextComponent implements OnChanges {

  @Input() public text: string;

  public segments: Array<Segment> = [];

  public ngOnChanges(): void {
    this.segments = parseInline(this.text);
  }

  public trackByIndex(index: number): number {
    return index;
  }
}
